module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color5.7d86f6cd.gif";